const o = "globalModal__content_ltINy", l = "globalModal__buttons_jB-yy", t = "globalModal__button_xJZ0o", _ = {
  globalModal__content: o,
  globalModal__buttons: l,
  globalModal__button: t
};
export {
  _ as default,
  t as globalModal__button,
  l as globalModal__buttons,
  o as globalModal__content
};
//# sourceMappingURL=globalModal.module.scss.js.map
